import {
  InputLabel,
  InputLabelProps,
  Theme,
  makeStyles,
  createStyles
} from "@material-ui/core"

import React from "react"

const useStyle = makeStyles(({spacing}: Theme) =>
  createStyles({
    label: {
      fontWeight: 500,
      color: "black",
      marginBottom: spacing(0.5),
      marginLeft: spacing(0.1)
    },
    labelDisabled: {
      fontWeight: 500,
      color: "gray",
      marginBottom: spacing(0.5),
      marginLeft: spacing(0.1)
    }
  })
)
const CustomLabel: React.FunctionComponent<InputLabelProps> = ({
  children,
  required,
  disabled,
  ...inputLabelProps
}) => {
  const classes = useStyle()
  return (
    <InputLabel
      disableAnimation
      shrink={false}
      className={classes.label}
      disabled={disabled}
      required={required}
      {...inputLabelProps}
    >
      {children}
    </InputLabel>
  )
}

export default CustomLabel
